import React, { useEffect, useRef } from 'react';
import { CrossIcon } from '../../helpers/icons';
import { Button } from '../Button';

// width can be xs, sm, md, lg, full
export const AsideModal = ({
  children,
  handleClose,
  shouldCloseOnClickOutside = false,
  title = '',
  width = 'xs',
  extraClasses = '',
}) => {
  const asideModalRef = useRef();

  useEffect(() => {
    if (asideModalRef.current) {
      const refrence = asideModalRef.current;
      refrence.showModal();
    }
  }, [asideModalRef]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <div className="position--fixed left--0 top--0 w--full h--full bg--black-400 z-index--sm">
      <dialog
        data-aside-modal="right"
        ref={asideModalRef}
        className={`w--${width} w-min--500 ${extraClasses}`}
        onClick={(e) => {
          if (!shouldCloseOnClickOutside) {
            e.preventDefault();
            e.stopPropagation();
          } else {
            handleClose();
          }
        }}
        onClose={() => handleClose()}
      >
        <dialog-head
          onClick={(e) => e.stopPropagation()}
          class="dialog-head h-min--50 p-l--md p-r--md d--flex align-items--center justify-content--between bg--black-50 border-bottom--black-100"
        >
          <div className="font--md font--600">{title}</div>
          <button
            type="button"
            className="font--md font--600 text--black-600 d--flex c--pointer radius--full bg--transparent"
            onClick={() => handleClose()}
            onKeyDown={handleKeyDown}
          >
            <CrossIcon width={20} height={20} />
          </button>
        </dialog-head>
        <dialog-body
          onClick={(e) => e.stopPropagation()}
          class="dialog-body p--md h--full"
        >
          {children}
        </dialog-body>
      </dialog>
    </div>
  );
};

export const AsideModalCancelButton = ({ label = 'Cancel', cb = () => {} }) => {
  return (
    <Button
      type="button"
      variant="contrast"
      color="black-600"
      btnClasses="btn w-max--150"
      onClick={cb}
    >
      {label}
    </Button>
  );
};

export const AsideModalSaveButton = ({
  label = 'Save',
  disabled,
  notClickable,
  title,
  cb = () => {},
  type = 'submit',
}) => {
  return (
    <Button
      type={type}
      variant="primary"
      color="white"
      btnClasses="btn w-max--150"
      disabled={disabled || notClickable}
      title={title}
      onClick={cb}
    >
      {disabled ? 'Please wait...' : label}
    </Button>
  );
};
